import { createFileRoute, notFound } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// The new tree's catch-all, as `_authenticated/$` is today's: without it a URL below `/next` that names no page falls
// to that one, and its not-found page shows below today's navbar. Here it shows in the shell, which offers the way out.
export const Route = createFileRoute('/_authenticated/next/$')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw notFound();
    },
});
